import React from 'react';
import './Componenst.css';

import loading from '../../img/loading.gif';
import persons from '../../img/profile.png';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createPerson, createTraitor, showError } from '../ViewCreator';
import Dropzone from 'react-dropzone';

function MyDropzone({ addNew = () => { } }) {


    const onDrop = (files) => {
        addNew(files, 20012)
    }


    const clearSubmit = async () => {
        console.log("Вставка зображення...");
      
        try {
          const clipboardItems = await navigator.clipboard.read(); // Отримання даних з буфера
          console.log("Отримані елементи:", clipboardItems);
          const rasterTypes = ["image/png", "image/jpeg", "image/webp"];
          for (const clipboardItem of clipboardItems) {
            for (const type of clipboardItem.types) {
              if (rasterTypes.includes(type)) {
              console.log("Тип:", type);
      

              if (type.startsWith("image/")) { // Перевіряємо, чи це зображення
                const blob = await clipboardItem.getType(type);
                console.log("Зображення у буфері:", blob);
      
                const arrayBuffer = await blob.arrayBuffer();
                const base64Image = _arrayBufferToBase64(arrayBuffer);
      
                console.log("Base64 зображення:", base64Image);
                addNew(base64Image, 20013);
                return; // Виходимо, щоб обробити лише перше зображення
              }
            }
            }
          }
      
          console.warn("Зображення в буфері не знайдено.");
        } catch (err) {
          console.error("Помилка при отриманні зображення:", err.name, err.message);
        }
      };

    return (
        <Dropzone onDrop={onDrop} className="drop">
            {({ getRootProps, getInputProps }) => (
               <section className="containerDrop">
               <div {...getRootProps({ className: "dropzone" })}>
                 <input {...getInputProps()} />
                 <h4>Перетягніть сюди файли або зображення (фотографії)</h4>
                 <h6>або натисніть на данний запис, щоб перейти до діалогового вікна вибору файлів</h6>
               </div>
               <button onClick={clearSubmit} className="submit-button">
                 Вставити
               </button>
             </section>
            )}
        </Dropzone>
    );
}

function _arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

export default MyDropzone;